import type { ReactNode } from "react";
import { useRef } from "react";

import { useMountEffect } from "@/hooks/useMountEffect";

export function TurnstileWidget({
	sitekey,
	onToken,
	onError,
}: {
	sitekey: string;
	onToken: (token: string) => void;
	onError: () => void;
}): ReactNode {
	const containerRef = useRef<HTMLDivElement>(null);
	const widgetIdRef = useRef<string | null>(null);

	useMountEffect(() => {
		const container = containerRef.current;
		if (!container || !window.turnstile) {
			onError();
			return;
		}

		widgetIdRef.current = window.turnstile.render(container, {
			sitekey,
			callback: onToken,
			theme: "dark",
			"error-callback": onError,
			"expired-callback": () => onToken(""),
		});

		return () => {
			if (widgetIdRef.current !== null && window.turnstile) {
				window.turnstile.remove(widgetIdRef.current);
				widgetIdRef.current = null;
			}
		};
	});

	return <div ref={containerRef} className="turnstile-container" />;
}
